import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { PagePath, PageState } from '../reducers/PageReducer';
import { EnrichedComponentCategory } from '../../domain/category/CategoryOperationDomains';
import ComponentName from '../../constant/ComponentName';
import { CustomFilter, CustomFilterFields } from '../../domain/ui/FilterDomains';

export type PageAction =
  | 'CHANGE_SIDEBAR_COLLAPSE'
  | 'CHANGE_HAMBURGER_MENU_TOGGLE'
  | 'CHANGE_ITEM_VIEW'
  | 'CHANGE_PAGE_PATH'
  | 'ADD_PAGE_PATH'
  | 'CHANGE_CURRENT_CATEGORY'
  | 'CHANGE_ENRICHED_CATEGORIES'
  | 'CHANGE_ACTIVE_PAGE_INDEX'
  | 'NEXT_PAGE'
  | 'PREVIOUS_PAGE'
  | 'SET_LANGUAGE'
  | 'CLEAR_PAGE'
  | 'CHANGE_CURRENT_COMPONENT'
  | 'CALCULATE_PAGE_PATH'
  | 'CHANGE_PAGE_FILTER'
  | 'CHANGE_METRIC_INTERVALS'
  | 'CHANGE_PAGE_FILTERS';

export const changeSidebarCollapse = (payload: boolean) => ({ type: 'CHANGE_SIDEBAR_COLLAPSE', payload }) as ReduxBaseAction<boolean, PageAction>;
export const toggleHamburgerMenu = (payload: boolean) => ({ type: 'CHANGE_HAMBURGER_MENU_TOGGLE', payload }) as ReduxBaseAction<boolean, PageAction>;
export const changeItemView = (payload: PageState['itemView']) =>
  ({
    type: 'CHANGE_ITEM_VIEW',
    payload,
  }) as ReduxBaseAction<PageState['itemView'], PageAction>;
export const changePagePath = (payload: PagePath[]) => ({ type: 'CHANGE_PAGE_PATH', payload }) as ReduxBaseAction<PagePath[], PageAction>;
export const addPagePath = (payload: PagePath) => ({ type: 'ADD_PAGE_PATH', payload }) as ReduxBaseAction<PagePath, PageAction>;
export const changeCurrentCategory = (payload: EnrichedComponentCategory | null) =>
  ({
    type: 'CHANGE_CURRENT_CATEGORY',
    payload,
  }) as ReduxBaseAction<EnrichedComponentCategory, PageAction>;
export const changeEnrichedCategories = (payload: Record<string, EnrichedComponentCategory>) =>
  ({
    type: 'CHANGE_ENRICHED_CATEGORIES',
    payload,
  }) as ReduxBaseAction<Record<string, EnrichedComponentCategory>, PageAction>;
export const changeActivePageIndex = (payload: number) => ({ type: 'CHANGE_ACTIVE_PAGE_INDEX', payload }) as ReduxBaseAction<number, PageAction>;
export const nextPage = () => ({ type: 'NEXT_PAGE' }) as ReduxBaseAction<number, PageAction>;
export const previousPage = () => ({ type: 'PREVIOUS_PAGE' }) as ReduxBaseAction<number, PageAction>;
export const changeLanguage = (payload: string) => ({ type: 'SET_LANGUAGE', payload }) as ReduxBaseAction<string, PageAction>;
export const clearPage = () => ({ type: 'CLEAR_PAGE' }) as ReduxBaseAction<void, PageAction>;
export const changeCurrentComponent = (payload: ComponentName) =>
  ({
    type: 'CHANGE_CURRENT_COMPONENT',
    payload,
  }) as ReduxBaseAction<ComponentName, PageAction>;

export const changePageFilter = (payload: { filter?: CustomFilter; items: CustomFilterFields[] }) =>
  ({
    type: 'CHANGE_PAGE_FILTER',
    payload,
  }) as ReduxBaseAction<
    {
      filter?: CustomFilter;
      items: CustomFilterFields[];
    } | null,
    PageAction
  >;

export const changePageFilters = (
  payload: Record<
    string,
    {
      filter?: CustomFilter;
      items: CustomFilterFields[];
    }
  >,
) =>
  ({
    type: 'CHANGE_PAGE_FILTERS',
    payload,
  }) as ReduxBaseAction<
    Record<
      string,
      {
        filter?: CustomFilter;
        items: CustomFilterFields[];
      }
    > | null,
    PageAction
  >;

export const calculatePagePath = (payload: { component: ComponentName; id: string; disablePathCalculation?: boolean }) => ({
  type: 'CALCULATE_PAGE_PATH',
  payload,
});

export const changeMetricIntervals = (payload: { metricIntervals: number[] }) =>
  ({
    type: 'CHANGE_METRIC_INTERVALS',
    payload,
  }) as ReduxBaseAction<
    {
      metricIntervals: number[];
    },
    PageAction
  >;
